import { render, staticRenderFns } from "./BidderContestView.vue?vue&type=template&id=6bea7a6e&scoped=true&"
import script from "./BidderContestView.vue?vue&type=script&lang=js&"
export * from "./BidderContestView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bea7a6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle})
